import API from '@/shared/plugins/Api/API'

class DomainV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _appUrl (appName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}`
  }

  async get (appName) {
    const response = await this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/domain`
    })
    return response
  }
}

export default DomainV3
